import CryptoJS from "crypto-js";

const secretKey = process.env.ESIM_APP_SECRET_KEY || "ESIM";

// Encrypt value
export function encryptData(data: string) {
    return CryptoJS.AES.encrypt(data, secretKey).toString();
}

// Decrypt value
export function decryptData(ciphertext: string) {
    const bytes = CryptoJS.AES.decrypt(ciphertext, secretKey);
    return bytes.toString(CryptoJS.enc.Utf8);
}

// Deterministic key hashing
function hashKey(key: string) {
    return CryptoJS.SHA256(key).toString(); 
}

// Wrapper to store encrypted key/value
export function setSecureItem(key: string, value: string) {
    const hashedKey = hashKey(key);
    const encValue = encryptData(value);
    localStorage.setItem(hashedKey, encValue);
}

// Wrapper to retrieve encrypted key/value
export function getSecureItem(key: string) {
    const hashedKey = hashKey(key);
    const encValue = localStorage.getItem(hashedKey);
    if (!encValue) return null;
    return encValue;
}
